import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import EmberDataExplorer from "./EmberDataExplorer";
import reportWebVitals from "./reportWebVitals";
import { createRoot } from "react-dom/client";

const container = document.getElementById("ember-data-explorer");
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <EmberDataExplorer
      initialCountry={window.country_or_region}
      initalMetric={window.metric}
      initialDataset={window.dataset}
      initialChartType={window.chart_type}
      initialFuel={window.fuel}
      initialComparison={window.comparison}
    />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
